import { gql, TypedDocumentNode } from '@common/hooks';
import {
  WorksRateCardsByAssignmentTermQueryCgResponse,
  WorksRateCardsByAssignmentTermQueryVariables,
} from '@common/graphql/schema';

export type WorksRateCardType = NonNullable<
  WorksRateCardsByAssignmentTermQueryCgResponse['worksRateCardsByAssignmentTerm']['worksRateCards']
>[number];

export type WorksRateCardItemType = NonNullable<
  WorksRateCardType['worksRateCardItems']
>[number];

export const WorksRateCardsByAssignmentTermQuery: TypedDocumentNode<
  WorksRateCardsByAssignmentTermQueryCgResponse,
  WorksRateCardsByAssignmentTermQueryVariables
> = gql`
  query WorksRateCardsByAssignmentTerm($termId: ID!) {
    worksRateCardsByAssignmentTerm(termId: $termId) {
      assignmentTerm {
        id
        effectiveAt
        billingRegularRate
      }
      worksRateCards {
        id
        effectiveDate
        worksRateCardItems {
          id
          name
          payCode
          expression
          factor
        }
      }
    }
  }
`;
